import useGetAccount from './useGetAccount'

/**
 * Returns true when the AI Assistant tab must be hidden entirely for this
 * team (toggled by superadmins in Django admin:
 * `team.settings.ai_assistant_hidden`). Escape hatch for AI-averse clients.
 *
 * Overrides the default always-visible-with-lock behavior: hides the nav
 * item on web and MS Teams and turns `/assistant` into a dashboard
 * redirect. Defaults to false (shown) for absent/legacy settings.
 */
const useGetIsAiAssistantHidden = (): boolean => {
  const account = useGetAccount()
  return !!account?.team?.settings?.ai_assistant_hidden
}

export default useGetIsAiAssistantHidden
